import React, {useEffect, useState} from 'react';
import {
    useTheme,
    Box,
    Stack,
    Typography,
    TextField,
    // Divider,
    // Switch,
    Button,
    Dialog,
    DialogTitle,
    DialogActions,
    DialogContent,
    DialogContentText,
    // RadioGroup,
    // Radio,
    // FormControlLabel,
    // FormControl,
    // InputLabel,
    // IconButton,
    // Checkbox,
    // Select,
    // MenuItem
    // Fade,
    // IconButton,
    // Menu,
    // MenuItem,
} from "@mui/material";
import LinearProgress from '@mui/material/LinearProgress';
// import EditIcon from '@mui/icons-material/Edit';
// import FormControl from '@mui/material/FormControl';
// import FormHelperText from '@mui/material/FormHelperText';
// import Input from '@mui/material/Input';
// import InputLabel from '@mui/material/InputLabel';
import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';

// import MenuIcon from '@mui/icons-material/Menu';
// import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
// import SearchIcon from '@mui/icons-material/Search';
// import DirectionsIcon from '@mui/icons-material/Directions';

import {tokens} from "../../theme";
import systemUserService from '../../services/SystemUserService';
// import YaMap from '../YaMap/YaMap';

const SystemUserEdit = ({systemUser=null, open, handleClose}) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const [loading, setLoading] = useState(true);
    const [change, setChange] = useState(true)
    const descriptionElementRef = React.useRef(null);

    

    useEffect(() => {
        if (systemUser) {
            setChange(false)
            setSystemUserLoginText(systemUser.login)
            setSystemUserName(systemUser.name)
        }
        else {
            setChange(true)
            setSystemUserLoginText("")
            setSystemUserName("")
        }

        setEditLoginFlag(false)

        
    }, [systemUser])

    // edit login
    const [systemUserLoginText, setSystemUserLoginText] = useState("")
    const [editLoginFlag, setEditLoginFlag] = useState(false)

    // edit name
    const [systemUserName, setSystemUserName] = useState("")
    const [errorName, setErrorName] = useState("")
    const handleChangeSystemUserName = (event) => {
        setSystemUserName(event.target.value)
        const pattern = /^[\p{L}\p{Emoji}]+$/u;
        if (!pattern.test(event.target.value) || event.target.value.length === 0) {
            setErrorName("Incorrect input")
        }
        else {
            setErrorName("")
        }
    }

    useEffect(() => {
        if (systemUser) {
            setChange(false)
            if (systemUserName !== systemUser.name) {
                setChange(true)
            }
        }
    }, [systemUser, systemUserName] )

    // save
    const [errorMessage, setErrorMessage] = useState("")
    const handleSave = async () => {
        setLoading(false)
        setErrorMessage("")
        if (errorName) {
            setErrorMessage("Error")
            setLoading(true)
            return
        }
        systemUser.name = systemUserName
        const put_system_user = await systemUserService.putSystemUser(systemUser)
        if (put_system_user.status !== 200) {
            setErrorMessage("Error updating request.")
            setLoading(true)
            return
        }
        setLoading(true)
        handleClose()
    }

    return (
            <Box>
                <Dialog
                    open={open}
                    onClose={handleClose}
                    scroll={'body'}
                    aria-labelledby="scroll-dialog-title"
                    aria-describedby="scroll-dialog-description"
                >
                    <DialogTitle id="scroll-dialog-title">
                        {systemUser 
                            ?   <Typography variant="h5" sx={{ color: colors.greenAccent[500] }}>
                                    {systemUser.name} {systemUser.surname}
                                </Typography>
                            :   <Typography variant="h5" sx={{ color: colors.greenAccent[500] }}>
                                    New system user
                                </Typography> 
                        }
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText
                            id="scroll-dialog-description"
                            ref={descriptionElementRef}
                            tabIndex={-1}
                            // p={5}
                        >
                            {/* <Divider /> */}
                            {/* Loading and errors */}
                            {!loading && <LinearProgress /> }
                            {errorMessage && <Typography>{errorMessage}</Typography>}
                            {/* Source of reference */}
                            {/* {setAppeal.is_open} */}
                            <Stack spacing={3}>
                                {/* Appeal */}
                                <Paper
                                    component="form"
                                    sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: 400 }}
                                > 
                                    <Stack>
                                        <Stack direction={"row"} sx={{ display: 'flex', alignItems: 'center', width: 400 }}>
                                            {/* Menu */}
                                            {/* <IconButton sx={{ p: '10px' }} aria-label="menu">
                                                <MenuIcon />
                                            </IconButton> */}
                                            <InputBase
                                                sx={{ ml: 1, flex: 1 }}
                                                placeholder="Source of appeal"
                                                value={systemUserLoginText}
                                                inputProps={{ 'aria-label': 'search google maps' }}
                                                // onChange={handleChangeSystemUser}
                                                disabled={!editLoginFlag}
                                            />
    
                                            {/* <IconButton type="button" sx={{ p: '10px' }} aria-label="edit" onClick={handleEditSystemUserName}>
                                                <EditIcon />
                                            </IconButton> */}
                                            {/* <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
                                            <Switch 
                                                checked={isOpen}
                                                onChange={handleChangeIsOpen}
                                                color="secondary"
                                                sx={{ p: '10px' }} aria-label="directions"
                                            /> */}
                                            {/* <Typography>{isOpen ? "Open" : "Close"}</Typography> */}
                                        </Stack>

                                    </Stack>
                                </Paper>
                                {/* New subscriber */}
                                <Paper
                                    component="form"
                                    sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: 400 }}
                                >
                                    <Stack spacing={1} width={'100%'}>
                                        {/* <FormControlLabel 
                                            control={
                                                <Checkbox
                                                    checked={newSubscriber}
                                                    onChange={handleChangeNewSoubscriber}
                                                    color='secondary'
                                                    icon={<AddCircleOutlineIcon />}
                                                    checkedIcon={<AddCircleOutlineIcon />}
                                                />} 
                                            label="New subscriber"
                                        /> */}
                                        <Stack spacing={1} p={'10px'}>
                                            <TextField
                                                value={systemUserName}
                                                onChange={handleChangeSystemUserName}
                                                required
                                                label="Name"
                                                color='secondary'
                                                error={errorName}
                                                helperText={errorName}
                                            />
                                        </Stack>
                                    </Stack>
                                </Paper>
                            </Stack>
                        </DialogContentText>
                    </DialogContent>
    
                    <DialogActions>
                        <Button onClick={handleClose} color="primary">
                            Cancel
                        </Button>
                        {change && (
                            <Button onClick={handleSave} color="primary">
                                Save
                            </Button>
                        )}
                    </DialogActions>
                </Dialog>
            </Box>
        );
    }
    export default SystemUserEdit;